export default __webpack_public_path__ + "static/clutch-logo-b0a93c2b03ceb331b10617d0fb704658.png";